"use strict";exports.name="@sainsburys-tech/icons",exports.version="3.6.0";
